import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface TechnicianListColumnsState {
  visibleKeys: Record<string, boolean>;
}

const initialState: TechnicianListColumnsState = {
  visibleKeys: {},
};

export const technicianListColumnsSlice = createSlice({
  name: 'technicianListColumns',
  initialState,
  reducers: {
    setVisibleKeys: (state, action: PayloadAction<Record<string, boolean>>) => {
      state.visibleKeys = action.payload;
    },
    setColumnVisibility: (
      state,
      action: PayloadAction<{ key: string; visible: boolean }>
    ) => {
      const { key, visible } = action.payload;
      state.visibleKeys[key] = visible;
    },
  },
});

export const { setVisibleKeys, setColumnVisibility } =
  technicianListColumnsSlice.actions;
export default technicianListColumnsSlice.reducer;
